/**
 * Layout nodes of given graph using custom made random layout algorithm.
 */
export async function doRandomLayoutAdvancedFromGraph(graph) {
    const classNodes = Object.values(graph.nodes).filter(node => !node.isDummy);
    classNodes.forEach(classNode => {
        let visualNode;
        if (classNode?.completeVisualNode?.isAnchored === true) {
            visualNode = classNode.completeVisualNode.coreVisualNode;
        }
        else {
            classNode.completeVisualNode.setPositionInCoreVisualNode(Math.ceil(Math.random() * 400 * Math.sqrt(classNodes.length)), Math.ceil(Math.random() * 250 * Math.sqrt(classNodes.length)));
            for (const edge of classNode.getAllOutgoingEdges()) {
                edge.visualEdge.visualEdge.waypoints = [];
            }
        }
    });
    return graph.mainGraph;
}
/**
 * The run method of this class performs random layout of prepared graph.
 */
export class RandomLayout {
    prepareFromGraph(graph, _configurations) {
        this.graph = graph;
    }
    runGeneralizationLayout() {
        throw new Error("Implement me if necessary");
    }
    run() {
        return doRandomLayoutAdvancedFromGraph(this.graph);
    }
    graph;
}
//# sourceMappingURL=basic-layout.js.map